const IconColor = Object.freeze({
    0: "#D52828" ,
    1: "#F4A14E",
    2: "#50C124"
});

module.exports = IconColor;